import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { useAuth } from "auth";
import issuer_services from "services/issuer_services";
import { treasuryIdSelector, networkTypeSelector } from "store/userSliceHelpers";
import type { PosByTreasury } from "utils/AxiosUtil";

export function useTerminals() {
  const { user } = useAuth();
  const treasuryId = useSelector(treasuryIdSelector);
  const networkType = useSelector(networkTypeSelector);

  return useQuery<PosByTreasury[]>({
    queryKey: ["terminals", treasuryId],
    queryFn: () => issuer_services.getTerminals(treasuryId!, networkType),
    enabled: !!user && !!treasuryId,
  });
}
